import { get, post, patch } from "../../xhr/api";

export const getAppealRequestDetails = (id) =>
  get(`api/tax-appeal/${id}`, {}, true);

export const verifyUnitCode = (data) =>
  post(`api/tax-appeal/verify-unit-access-key`, {}, data, true);

export const checkShowOptions = (id) =>
  patch(`api/tax-appeal/${id}/check-show-options`, {}, {});

export const previewAndDownloadAppealFile = (url) =>
  get(`${url}`, { responseType: "blob" }, true);
